{
    "name": "ds-booking",
    "version": "0.0.1",
    "description": "A WIP application to help our customer’s users/clients to request appointments with the business.",
    "main": "frontend/src/index.html",
    "devDependencies": {
        "@types/jest": "^29.5.12",
        "@types/node": "^20.11.16",
        "cypress-cucumber-preprocessor": "^4.3.1",
        "dotenv-override": "^5.0.1",
        "husky": "^9.0.10"
    },
    "overrides": {
        "brace-expansion": "^1.1.21"
    },
    "scripts": {
        "test": "cd frontend && npm run test && cd .. && cd service && npm run test && cd ..",
        "test:verbose": "cd frontend && npm run test:verbose && cd .. && cd service && npm run test:verbose && cd ..",
        "lint": "cd frontend && npm run lint && cd .. && cd service && npm run lint && cd ..",
        "prettierFix": "cd frontend && npm run prettierFix && cd .. && cd service && npm run prettierFix && cd ..",
        "prettierCheck": "cd frontend && npm run prettierCheck && cd .. && cd service && npm run prettierCheck && cd ..",
        "deploy": "cd service && npm run deploy && cd ..",
        "postinstall": "npm run prepare && cd frontend && npm i --ignore-scripts && cd .. && cd service && npm i --ignore-scripts && cd ..",
        "prepare": "husky install"
    },
    "repository": {
        "type": "git",
        "url": "git+https://github.com/DaySmart/daysmart-booking.git"
    },
    "keywords": [
        "booking"
    ],
    "author": "DaySmart Software",
    "license": "Apache-2.0",
    "bugs": {
        "url": "https://github.com/DaySmart/daysmart-booking/issues"
    },
    "homepage": "https://github.com/DaySmart/daysmart-booking#readme"
}
